import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";
import type { DataImportTarget } from "../../../../api/types/dataImportTypes";

interface Props {
  open: boolean;
  importTarget?: DataImportTarget;
  onClose: () => void;
  onConfirm: () => void;
}

const rollbackNotices: Partial<Record<DataImportTarget, string>> = {
  Investors:
    "Investors this import created are deleted in Entrilia and values it changed are restored. The rollback is refused, and nothing in this import changes, if a new investor is already in Fund Accounting, is in a fund or was edited, or if a value the import changed was edited or its investor deleted.",
  CommitmentDrafts:
    "Drafts this import created in Fund Accounting are deleted, including drafts left without their line. Before anything is deleted, the rollback is refused if a draft was posted, released, edited or deleted, has lines, documents, links or notes added, or if it is not known whether a row created a draft. Each draft is checked again just before it is deleted: a draft changed in Fund Accounting during the rollback is kept while drafts already deleted stay deleted, and a line, document or note added at that moment is deleted with its draft.",
};

const ConfirmImportRollbackDialog = ({ open, importTarget, onClose, onConfirm }: Props) => {
  const rollbackNotice = importTarget && rollbackNotices[importTarget];
  return (
    <SmallDialog open={open}>
      <DialogTitle>Confirm</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <WarningDialogIcon sx={{ width: 80, height: 80 }} />
          <Typography variant="h6">Rollback import?</Typography>
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography color="textSecondary" sx={{ textAlign: "center" }}>
              You&apos;re about to rollback all changes made by this import. This action is permanent and can&apos;t be
              undone.
            </Typography>{" "}
            {rollbackNotice && (
              <Typography color="textSecondary" sx={{ textAlign: "center" }}>
                {rollbackNotice}
              </Typography>
            )}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Rollback
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default ConfirmImportRollbackDialog;
